/* ================================================================
   The Portal 0 — storefront behaviour.
   The header, ticker and footer are Liquid sections now, so this
   file only wires up what the markup cannot do on its own:
   the mobile menu, the search overlay, the product gallery,
   quantity steppers, and cart line updates.
   ================================================================ */
(function () {
  'use strict';

  function on(el, evt, fn) { if (el) { el.addEventListener(evt, fn); } }

  /* ---------- mobile menu ---------- */
  function initMobileNav() {
    var btn = document.getElementById('navToggle');
    var panel = document.getElementById('mobileNav');
    if (!btn || !panel) { return; }

    on(btn, 'click', function () {
      var opening = panel.hasAttribute('hidden');
      if (opening) { panel.removeAttribute('hidden'); }
      else { panel.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', String(opening));
    });

    on(panel, 'click', function (e) {
      if (e.target.tagName === 'A') {
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- search overlay ---------- */
  function initSearch() {
    var btn = document.getElementById('searchToggle');
    var bar = document.getElementById('searchBar');
    var input = document.getElementById('searchInput');
    var close = document.getElementById('searchClose');
    if (!btn || !bar) { return; }

    function open() {
      bar.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
      if (input) { input.focus(); }
    }
    function shut() {
      bar.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    }

    on(btn, 'click', function () { bar.hasAttribute('hidden') ? open() : shut(); });
    on(close, 'click', shut);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && !bar.hasAttribute('hidden')) { shut(); btn.focus(); }
    });

    // Landing on /search with a query: show the box already filled in.
    if (input && input.value) { open(); }
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    var main = document.getElementById('galMain');
    var thumbs = document.querySelectorAll('.gal__thumb');
    if (!main || !thumbs.length) { return; }

    thumbs.forEach(function (thumb) {
      on(thumb, 'click', function () {
        thumbs.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        thumb.setAttribute('aria-selected', 'true');
        var src = thumb.getAttribute('data-src');
        if (src) {
          main.src = src;
          if (thumb.getAttribute('data-srcset')) { main.srcset = thumb.getAttribute('data-srcset'); }
          main.alt = thumb.getAttribute('data-alt') || main.alt;
        }
      });
    });
  }

  /* ---------- quantity steppers ---------- */
  function initQuantity() {
    document.querySelectorAll('.qty').forEach(function (group) {
      var field = group.querySelector('input');
      if (!field) { return; }

      group.querySelectorAll('button[data-step]').forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
          var min = parseInt(field.getAttribute('min'), 10);
          if (isNaN(min)) { min = 0; }
          var next = (parseInt(field.value, 10) || 0) + step;
          field.value = Math.max(min, next);
          // Cart lines post the change; the PDP just updates the number.
          field.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- cart line changes ---------- */
  function initCartLines() {
    var form = document.getElementById('cartForm');
    if (!form) { return; }

    // A quantity change or a remove click submits the real cart form, so the
    // totals Shopify sends back are the ones the customer sees. No local math.
    form.querySelectorAll('.cart-line input[name^="updates"]').forEach(function (field) {
      on(field, 'change', function () { form.submit(); });
    });
  }

  /* ---------- variant picker ---------- */
  function initVariants() {
    var root = document.querySelector('[data-product-variants]');
    if (!root) { return; }

    var variants = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var idField = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-variant-price]');
    var addBtn = root.querySelector('[data-add-button]');
    var skuEl = root.querySelector('[data-variant-sku]');

    function selectedOptions() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-option-index]'),
        function (group) {
          var picked = group.querySelector('input:checked');
          return picked ? picked.value : null;
        }
      );
    }

    function update() {
      var chosen = selectedOptions();
      /* A product with only the default variant renders NO option groups --
         main-product.liquid guards them with `unless has_only_default_variant`
         -- so selectedOptions() returns []. Matching then compared the
         variant's own "Default Title" against undefined, found nothing, and
         fell through to the no-match branch: disabled button reading
         "Unavailable". That is 683 of 870 products, 523 of them in stock.
         With no options to choose, the single variant IS the selection. */
      var match = chosen.length
        ? variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === chosen[i]; });
          })
        : variants[0];

      if (!match) {
        addBtn.disabled = true;
        addBtn.querySelector('span').textContent = addBtn.getAttribute('data-unavailable');
        return;
      }

      idField.value = match.id;
      if (priceEl) { priceEl.innerHTML = match.price_formatted; }
      if (skuEl) { skuEl.textContent = match.sku || ''; }
      addBtn.disabled = !match.available;
      addBtn.querySelector('span').textContent = match.available
        ? addBtn.getAttribute('data-add')
        : addBtn.getAttribute('data-sold-out');
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      on(input, 'change', update);
    });
    update();
  }


  /* ---------- gashapon pool preview ----------
     Previews a random booster's printed contents. Purely a demo: it never
     touches the cart and never claims to be the unit that ships. The draw
     is uniform, matching the copy the section renders. */
  function initGashapon() {
    var gm = document.getElementById('gm');
    if (!gm) { return; }

    var sec    = gm.closest('.gasha');
    var pool   = [].slice.call(document.querySelectorAll('#gmPool li'));
    var result = document.getElementById('gmResult');
    var go     = document.getElementById('gmGo');
    var crank  = document.getElementById('gmCrank');
    if (!pool.length || !result || !go) { return; }

    var calm  = window.matchMedia('(prefers-reduced-motion:reduce)');
    var tally = pool.map(function () { return 0; });
    // the booster's code, so the pull line is not hard-coded to one product
    var code  = sec.getAttribute('data-code') || '';

    // colour comes from the .c-* palette class, not markup, so an art
    // variant can remap the whole set from CSS alone
    function capsuleColour(el) {
      return getComputedStyle(el).getPropertyValue('--c').trim() || '#c6ff2e';
    }

    function reveal(i) {
      var li = pool[i];
      tally[i]++;
      var total = tally.reduce(function (a, b) { return a + b; }, 0);

      pool.forEach(function (o, n) {
        o.classList.toggle('is-hit', n === i);
        var t = o.querySelector('[data-tally]');
        if (t) { t.textContent = tally[n] ? '\u00d7' + tally[n] : '\u2014'; }
      });
      li.classList.remove('is-flash');
      void li.offsetWidth;
      li.classList.add('is-flash');

      result.style.setProperty('--c', capsuleColour(li));
      result.classList.remove('is-empty', 'is-in');
      result.innerHTML =
        (calm.matches ? '' : '<span class="r-fx" aria-hidden="true"></span>') +
        '<span class="r-code">Pull ' + total +
          (code ? ' \u00b7 ' + code + ' ' + li.getAttribute('data-no') : '') + '</span>' +
        '<span class="r-name">' + li.getAttribute('data-name') + '</span>' +
        '<span class="r-raw">' + li.getAttribute('data-raw') + '</span>';
      void result.offsetWidth;
      result.classList.add('is-in');
    }

    // Two beats. deliver() runs the crank and drops a CLOSED capsule; the
    // result is drawn up front but held in `pending` until open() cracks it.
    // The waiting shell carries no item colour, so nothing on screen betrays
    // the result before the reveal.
    var stage = 'idle';        // idle | delivering | waiting | opening
    var pending = -1;

    function armOpen() {
      stage = 'waiting';
      sec.classList.add('is-armed');
      go.querySelector('span').textContent = 'Crack it open';
      go.classList.add('btn--pulse');
      result.style.removeProperty('--c');
      result.classList.remove('is-in');
      result.classList.add('is-empty');
      result.innerHTML = '<p class="r-hint r-hint--wait">Capsule delivered</p>';
    }

    function finish() {
      stage = 'idle';
      sec.classList.remove('is-armed');
      go.querySelector('span').textContent = 'Crank again';
    }

    function deliver() {
      if (stage !== 'idle') { return; }
      stage = 'delivering';
      pending = Math.floor(Math.random() * pool.length);

      if (calm.matches) { reveal(pending); finish(); return; }

      gm.className = 'gm is-cranking';
      setTimeout(function () { gm.className = 'gm is-spinning'; }, 150);
      setTimeout(function () { gm.classList.add('is-dropping'); }, 280);
      setTimeout(function () { gm.classList.remove('is-spinning'); }, 440);
      // the capsule leaves the tray and travels out toward the viewer,
      // then hovers there large until it is cracked
      setTimeout(function () { gm.className = 'gm is-rising'; }, 580);
      setTimeout(function () { gm.className = 'gm is-waiting'; armOpen(); }, 960);
    }

    function open() {
      if (stage !== 'waiting') { return; }
      stage = 'opening';
      go.classList.remove('btn--pulse');
      gm.className = 'gm is-open';
      setTimeout(function () { reveal(pending); }, 60);
      setTimeout(finish, 520);
    }

    function turn() {
      if (stage === 'idle') { deliver(); }
      else if (stage === 'waiting') { open(); }
    }

    // cracking it by clicking the capsule itself is the obvious gesture;
    // the stage guard makes the duplicate event from the crank harmless
    on(gm, 'click', function () { if (stage === 'waiting') { open(); } });
    on(go, 'click', turn);
    on(crank, 'click', turn);
  }

  /* ---------- horizontal step shelf ----------
     A scroll-snap container snaps away any intermediate scrollLeft, which
     cancels scrollBy({behavior:'smooth'}). So the arrows animate with rAF
     and snapping is suspended for the duration. */
  function initShelf() {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(document.querySelectorAll('[data-shelf]'), function (shelf) {
      var wrap = shelf.closest('.shelf-wrap');
      var nav  = wrap && wrap.querySelector('.shelf-nav');
      if (!nav) { return; }
      var btns = nav.querySelectorAll('.shelf-btn');
      var busy = false;

      function stepWidth() {
        var first = shelf.firstElementChild;
        if (!first) { return 260; }
        var gap = parseFloat(getComputedStyle(shelf).columnGap) || 18;
        return first.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = shelf.scrollWidth - shelf.clientWidth - 2;
        btns[0].disabled = shelf.scrollLeft <= 2;
        btns[1].disabled = shelf.scrollLeft >= max;
      }
      function finish(target) {
        shelf.scrollLeft = target;
        shelf.style.scrollSnapType = '';
        busy = false;
        sync();
      }
      function slide(dir) {
        if (busy) { return; }
        var max    = shelf.scrollWidth - shelf.clientWidth;
        var start  = shelf.scrollLeft;
        var target = Math.max(0, Math.min(max, start + dir * stepWidth()));
        if (target === start) { return; }
        if (reduce) { finish(target); return; }
        busy = true;
        shelf.style.scrollSnapType = 'none';
        var t0 = null, dur = 320;
        requestAnimationFrame(function tick(t) {
          if (t0 === null) { t0 = t; }
          var k = Math.min(1, (t - t0) / dur);
          var e = k < .5 ? 2 * k * k : -1 + (4 - 2 * k) * k;   // easeInOutQuad
          shelf.scrollLeft = start + (target - start) * e;
          if (k < 1) { requestAnimationFrame(tick); } else { finish(target); }
        });
      }

      Array.prototype.forEach.call(btns, function (b) {
        on(b, 'click', function () { slide(parseInt(b.getAttribute('data-dir'), 10)); });
      });
      on(shelf, 'scroll', function () { if (!busy) { sync(); } });
      on(window, 'resize', sync);
      sync();
    });
  }

  /* ---------- policy pages ----------
     Shopify renders /policies/* into its own fixed markup and a theme
     cannot template it. So the breadcrumb and the rail that lets you
     reach the other three policies are added here, client side. Purely
     additive: without JS the page is still the styled, readable policy. */
  var POLICIES = [
    ['/policies/privacy-policy',   'Privacy policy'],
    ['/policies/refund-policy',    'Refund policy'],
    ['/policies/shipping-policy',  'Shipping policy'],
    ['/policies/terms-of-service', 'Terms of service']
  ];

  function initPolicyChrome() {
    var box = document.querySelector('.shopify-policy__container');
    if (!box) { return; }
    var here = location.pathname.replace(/\/$/, '');

    // Shopify emits title and body as two siblings. Wrapping them makes the
    // container a clean two-child grid (rail | column); leaving them loose
    // puts them in separate grid rows and opens a gap under the heading.
    var col = document.createElement('div');
    col.className = 'policy__body';
    var title = box.querySelector('.shopify-policy__title');
    var body  = box.querySelector('.shopify-policy__body');
    if (title && body) {
      box.insertBefore(col, title);
      col.appendChild(title);
      col.appendChild(body);
    }

    var rail = document.createElement('aside');
    rail.className = 'policy__nav';
    rail.setAttribute('aria-label', 'Policies');
    rail.innerHTML = '<span class="lbl">Legal</span><div>' +
      POLICIES.map(function (p) {
        var cur = p[0] === here ? ' aria-current="page"' : '';
        return '<a href="' + p[0] + '"' + cur + '>' + p[1] + '</a>';
      }).join('') + '</div>';
    box.insertBefore(rail, box.firstChild);

    var h1 = box.querySelector('.shopify-policy__title h1');
    var crumbs = document.createElement('nav');
    crumbs.className = 'crumbs';
    crumbs.setAttribute('aria-label', 'Breadcrumb');
    crumbs.innerHTML =
      '<a href="/">Home</a>' +
      '<svg viewBox="0 0 24 24"><use href="#icon-chev"/></svg>' +
      '<span aria-current="page">' + (h1 ? h1.textContent : 'Policy') + '</span>';
    box.parentNode.insertBefore(crumbs, box);

  }


  // Prototype keeps them in a folder; Shopify's asset namespace is flat, so
  // the theme copy of this file overrides the prefix to 'carrier-'.
  var CARRIER_LOGO_BASE = window.TP0_ASSET_BASE || '';

  var CARRIERS = [
    ['US', 'USPS',           '\uD83C\uDDFA\uD83C\uDDF8'],
    ['JP', 'Japan Post',     '\uD83C\uDDEF\uD83C\uDDF5'],
    ['GB', 'Royal Mail',     '\uD83C\uDDEC\uD83C\uDDE7'],
    ['DE', 'Deutsche Post',  '\uD83C\uDDE9\uD83C\uDDEA'],
    ['FR', 'La Poste',       '\uD83C\uDDEB\uD83C\uDDF7'],
    ['CA', 'Canada Post',    '\uD83C\uDDE8\uD83C\uDDE6'],
    ['AU', 'Australia Post', '\uD83C\uDDE6\uD83C\uDDFA'],
    ['TW', 'Chunghwa Post',  '\uD83C\uDDF9\uD83C\uDDFC'],
    ['ES', 'Correos',        '\uD83C\uDDEA\uD83C\uDDF8'],
    ['IT', 'Poste Italiane', '\uD83C\uDDEE\uD83C\uDDF9'],
    ['NL', 'PostNL',         '\uD83C\uDDF3\uD83C\uDDF1'],
    ['CH', 'Swiss Post',     '\uD83C\uDDE8\uD83C\uDDED'],
    ['SG', 'SingPost',       '\uD83C\uDDF8\uD83C\uDDEC'],
    ['KR', 'Korea Post',     '\uD83C\uDDF0\uD83C\uDDF7']
  ];

  function carrierPlate(c) {
    // c = [countryCode, operatorName, flagEmoji]
    // The fallback is carried in data-* and applied by a real listener
    // below, not an inline onerror -- the fallback markup contains quotes
    // and nesting it inside an attribute silently broke the handler.
    return '<span class="carrier" data-cc="' + c[0] + '" data-name="' + c[1] +
           '" data-flag="' + c[2] + '">' +
             '<img class="carrier__logo" src="' + CARRIER_LOGO_BASE + c[0].toLowerCase() +
             '.png" alt="' + c[1] + '">' +
           '</span>';
  }

  // Swap a plate back to flag + name. Called on error, and also for images
  // that had already failed before the listener was attached.
  function carrierFallback(plate) {
    if (!plate || plate.dataset.fell) { return; }
    plate.dataset.fell = '1';
    var bits = '';
    if (plate.dataset.flag) { bits += '<span class="carrier__flag" aria-hidden="true">' + plate.dataset.flag + '</span>'; }
    bits += '<span class="carrier__name">' + plate.dataset.name + '</span>';
    if (plate.dataset.cc) { bits += '<span class="carrier__cc">' + plate.dataset.cc + '</span>'; }
    plate.innerHTML = bits;
  }

  function wireCarrierFallbacks(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.carrier[data-cc]'), function (plate) {
      var img = plate.querySelector('img');
      if (!img) { return; }
      img.addEventListener('error', function () { carrierFallback(plate); });
      // a 404 can complete before this runs
      if (img.complete && img.naturalWidth === 0) { carrierFallback(plate); }
    });
  }

  function initCarrierMarquee() {
    if (!/\/policies\/shipping-policy\/?$/.test(location.pathname)) { return; }
    // Placed after the whole policy container, not inside the body: the
    // body is held to a 72ch reading measure and a marquee wants the full
    // width. This also keeps it below the contact block rather than above.
    var box = document.querySelector('.shopify-policy__container');
    if (!box || document.querySelector('.carriers')) { return; }

    // split across two rails so they can travel in opposite directions
    var half = Math.ceil(CARRIERS.length / 2);
    var rails = [CARRIERS.slice(0, half), CARRIERS.slice(half)];

    var html = '<section class="carriers" aria-label="Delivering postal services">' +
      '<div class="carriers__head">' +
        '<h2>Carried by the national post</h2>' +
        '<p>Your parcel is handed to the destination country&rsquo;s own postal service.</p>' +
      '</div>';

    rails.forEach(function (set, i) {
      // the track is duplicated so translateX(-50%) loops seamlessly
      var plates = set.map(carrierPlate).join('');
      html += '<div class="carriers__rail">' +
                '<div class="carriers__track carriers__track--' + (i ? 'b' : 'a') + '" aria-hidden="' + (i ? 'true' : 'false') + '">' +
                  plates + plates +
                '</div></div>';
    });
    // FedEx Express is a private carrier under contract, not a national
    // post, so it sits in its own labelled row rather than being mixed
    // into the rails above. Same logo-then-fallback behaviour.
    html += '<div class="carriers__express">' +
              '<span class="lbl">Express</span>' +
              '<span class="carrier carrier--express" data-cc="" data-name="FedEx Express" data-flag="">' +
                '<img class="carrier__logo" src="' + CARRIER_LOGO_BASE + 'fedex.png" alt="FedEx Express">' +
              '</span>' +
              '<span class="carriers__express-note">Contracted partner &middot; expedited service</span>' +
            '</div>';

    html += '</section>';

    box.insertAdjacentHTML('afterend', html);
    wireCarrierFallbacks(box.nextElementSibling);
  }

  /* ---------- guest order tracking ----------
     Lets someone track without signing in, using the number from their
     shipping email. Same destination-aware routing as the signed-in order
     page: the parcel is handed to the destination country's post, so the
     country decides the carrier, not the number's format.

     The country -> carrier table lives inside initGuestTrack as CARRIERS and
     is duplicated from snippets/carrier-links.liquid, which does the same job
     in Liquid for signed-in orders. Liquid cannot read JSON, so there is no
     single source without a build step. If you add a country, add it in BOTH
     places. A second module-level copy of the same table used to sit here and
     was never read by anything; it is deleted rather than kept in step with
     nothing. */

  /* Guest order lookup.

     Posts order number + email to the App Proxy (backend/order-lookup),
     which verifies the pair against the Admin API. A theme cannot do this
     itself: Liquid only renders orders Shopify has already authenticated.

     The rendered result reuses the signed-in order page's classes (.jm,
     .trk, .bill) so there is one set of styles, not two. Every failure --
     wrong pair, missing order, proxy not deployed -- reports the SAME
     message, because distinguishing them would let someone enumerate
     which order numbers exist. */
  /* A prize exchange order does not wait on us -- it waits on Takara Tomy
     shipping the prize to us in region. The exchange page already publishes
     that status per round, so the order page says what is actually happening
     and links there, instead of asking the customer to open a support ticket
     for an answer we have already written down. */
  function exchangeRound(lines) {
    for (var i = 0; i < (lines || []).length; i++) {
      var t = lines[i].title || '';
      if (!/prize\s*exchange/i.test(t)) { continue; }
      var m = t.match(/vol\.?\s*(\d+)/i);
      if (!m) { return { handle: 'prize-service', label: '' }; }
      var n = m[1];
      /* the handles are not uniform: vol2 has no dash, 3 and 4 do */
      return { handle: n === '2' ? 'prize-service-vol2' : 'prize-service-vol-' + n,
               label: ' Vol.' + n };
    }
    return null;
  }

  function initGuestTrack() {
    var form = document.getElementById('guestTrack');
    if (!form) { return; }
    var out = document.getElementById('guestTrackOut');
    var btn = form.querySelector('button[type="submit"]');
    var endpoint = form.getAttribute('data-endpoint') || '/apps/track';

    var STEPS = ['Order confirmed', 'In transit', 'Out for delivery', 'Delivered'];
    /* Shopify only polls carriers it recognises. These parcels ship as
       "Other", so shipment_status is very often absent -- and defaulting
       that to "order confirmed" told customers nothing had happened to a
       parcel that left Taipei two weeks ago. A fulfillment existing means
       it has been dispatched, so that is the floor. */
    var PCT = { confirmed: 8, in_transit: 48, out_for_delivery: 88,
                ready_for_pickup: 88, attempted_delivery: 88, delivered: 100 };
    var DISPATCHED = 30;

    var CARRIERS = {"US":["USPS","https://tools.usps.com/go/TrackConfirmAction?tLabels=",""],"GB":["Royal Mail","https://www.royalmail.com/track-your-item#/tracking-results/",""],"JP":["Japan Post","https://trackings.post.japanpost.jp/services/srv/search/direct?reqCodeNo1=","&searchKind=S002&locale=en"],"DE":["Deutsche Post","https://www.deutschepost.de/sendung/simpleQueryResult.html?form.sendungsnummer=",""],"FR":["La Poste","https://www.laposte.fr/outils/suivre-vos-envois?code=",""],"CA":["Canada Post","https://www.canadapost-postescanada.ca/track-reperage/en#/resultList?searchFor=",""],"AU":["Australia Post","https://auspost.com.au/mypost/track/#/details/",""],"ES":["Correos","https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number=",""],"IT":["Poste Italiane","https://www.poste.it/cerca/index.html#/risultati-spedizioni/",""],"NL":["PostNL","https://jouw.postnl.nl/track-and-trace/",""],"CH":["Swiss Post","https://www.post.ch/swisspost-tracking?formattedParcelCodes=",""],"SG":["SingPost","https://www.singpost.com/track-items?trackingNumber=",""],"KR":["Korea Post","https://service.epost.go.kr/trace.RetrieveEmsRigiTraceList.comm?ems_gubun=E&POST_CODE=",""]};
    var BOTH_URL   = 'https://t.17track.net/en#nums=';

    function progress(f) {
      var p = PCT[f.status];
      return p == null ? DISPATCHED : p;
    }

    function esc(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function money(m) {
      if (!m) { return ''; }
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: m.currency
        }).format(parseFloat(m.amount));
      } catch (e) { return m.amount + ' ' + m.currency; }
    }

    /* Route geometry, precomputed per destination and kept identical to
       snippets/journey-map.liquid. The land outlines are already on the
       page as #wmLand, rendered once by the world-map snippet. */
  var JM_ROUTES = {"US":[796,143,"M407,191 Q601,42 796,143","226 36 751 221"],"GB":[65,102,"M407,191 Q236,33 65,102","-94 39 661 194"],"JP":[453,155,"M407,191 Q430,154 453,155","250 120 360 106"],"DE":[98,106,"M407,191 Q253,46 98,106","-46 52 597 176"],"FR":[76,121,"M407,191 Q241,48 76,121","-78 50 639 188"],"CA":[774,90,"M407,191 Q591,19 774,90","236 26 709 209"],"AU":[443,355,"M407,191 Q425,219 443,355","51 163 748 220"],"ES":[59,141,"M407,191 Q233,54 59,141","-103 50 672 198"],"IT":[104,133,"M407,191 Q256,64 104,133","-37 64 585 172"],"NL":[84,103,"M407,191 Q246,40 84,103","-66 46 624 184"],"CH":[92,121,"M407,191 Q250,52 92,121","-55 55 609 179"],"SG":[358,268,"M407,191 Q382,200 358,268","156 163 452 133"],"KR":[424,154,"M407,191 Q416,159 424,154","236 120 360 106"],"TW":[405,195,"M407,191 Q406,192 405,195","226 140 360 106"],"HK":[386,200,"M407,191 Q397,188 386,200","216 142 360 106"],"MY":[352,259,"M407,191 Q380,197 352,259","169 163 422 124"],"TH":[350,221,"M407,191 Q378,185 350,221","198 153 360 106"],"PH":[408,230,"M407,191 Q407,198 408,230","228 158 360 106"],"ID":[386,280,"M407,191 Q396,206 386,280","150 163 493 145"],"VN":[370,226,"M407,191 Q389,192 370,226","208 156 360 106"],"IN":[289,205,"M407,191 Q348,160 289,205","168 139 360 106"],"NZ":[550,405,"M407,191 Q478,216 550,405","20 163 918 270"],"SE":[121,77,"M407,191 Q264,36 121,77","-40 40 607 179"],"NO":[93,76,"M407,191 Q250,27 93,76","-60 37 620 182"],"DK":[96,90,"M407,191 Q251,36 96,90","-49 45 601 177"],"FI":[141,72,"M407,191 Q274,38 141,72","-34 38 616 181"],"PL":[123,104,"M407,191 Q265,52 123,104","-9 60 549 161"],"AT":[110,118,"M407,191 Q259,57 110,118","-28 61 574 169"],"BE":[82,109,"M407,191 Q245,42 82,109","-69 47 628 185"],"IE":[47,99,"M407,191 Q227,26 47,99","-121 32 695 205"],"PT":[47,144,"M407,191 Q227,51 47,144","-121 47 695 205"],"CZ":[112,111,"M407,191 Q260,53 112,111","-25 59 570 168"],"MX":[784,196,"M407,191 Q596,73 784,196","231 58 728 214"],"BR":[925,318,"M407,191 Q666,105 925,318","166 95 1001 294"],"AR":[893,397,"M407,191 Q650,144 893,397","181 152 939 276"],"CL":[871,388,"M407,191 Q639,139 871,388","191 153 896 264"],"ZA":[133,371,"M407,191 Q270,176 133,371","-133 162 806 237"],"AE":[219,196,"M407,191 Q313,134 219,196","131 126 363 107"],"SA":[195,195,"M407,191 Q301,125 195,195","96 117 410 120"],"IL":[166,172,"M407,191 Q287,104 166,172","54 98 466 137"],"TR":[167,146,"M407,191 Q287,90 167,146","55 90 464 136"],"RU":[236,84,"M407,191 Q322,73 236,84","43 55 557 164"],"CN":[359,156,"M407,191 Q383,154 359,156","203 121 360 106"],"GR":[130,145,"M407,191 Q269,78 130,145","1 77 535 157"],"HU":[124,119,"M407,191 Q265,62 124,119","-8 66 547 161"],"RO":[139,123,"M407,191 Q273,69 139,123","14 73 518 152"],"UA":[156,115,"M407,191 Q282,69 156,115","36 74 492 145"],"CO":[863,257,"M407,191 Q635,77 863,257","195 72 881 259"],"PE":[861,302,"M407,191 Q634,97 861,302","195 103 877 258"],"EG":[155,185,"M407,191 Q281,107 155,185","38 98 487 143"]};

    function journey(pct, dest, cc) {
      var r = JM_ROUTES[cc];
      if (!r) {
        /* country not in the table: plain arc, no map */
        var arc = 'M40,92 Q300,4 560,92';
        return '<div class="jm" role="img" aria-label="Parcel journey, ' + pct + ' percent complete">' +
          '<svg class="jm__svg jm__svg--plain" viewBox="0 0 600 120" preserveAspectRatio="none" aria-hidden="true">' +
            '<path d="' + arc + '" fill="none" stroke="var(--line)" stroke-width="2" stroke-dasharray="6 7"/>' +
            '<path class="jm__done" d="' + arc + '" pathLength="100" stroke-dasharray="' + pct + ' 100"/>' +
            '<circle class="jm__o" cx="40" cy="92" r="6"/>' +
            '<circle class="jm__d' + (pct === 100 ? ' is-arrived' : '') + '" cx="560" cy="92" r="6"/>' +
          '</svg>' + ends(pct, dest) + '</div>';
      }
      var d = r[2];
      return '<div class="jm jm--map" role="img" aria-label="Route from Taipei to ' + esc(dest) +
             ', ' + pct + ' percent of the way through delivery">' +
        '<svg class="jm__svg" viewBox="' + r[3] + '" preserveAspectRatio="xMidYMid slice" aria-hidden="true">' +
          '<use href="#wmLand" class="jm__land"/>' +
          '<path class="jm__route" d="' + d + '"/>' +
          '<path class="jm__done" d="' + d + '" pathLength="100" stroke-dasharray="' + pct + ' 100"/>' +
          '<circle class="jm__o" cx="407" cy="191" r="6"/>' +
          '<circle class="jm__d' + (pct === 100 ? ' is-arrived' : '') + '" cx="' + r[0] + '" cy="' + r[1] + '" r="6"/>' +
          '<g class="jm__mark"><circle r="9"/><path d="M0,-5 L4.5,4 L0,1.6 L-4.5,4 Z"/>' +
            '<animateMotion dur="1.9s" fill="freeze" calcMode="linear" rotate="auto" ' +
              'keyPoints="0;' + (pct / 100) + '" keyTimes="0;1" path="' + d + '"/>' +
          '</g>' +
        '</svg>' + ends(pct, dest) +
        '<p class="jm__caveat">Position shows delivery progress, not a live location.</p>' +
      '</div>';
    }

    function ends(pct, dest) {
      return '<div class="jm__ends"><span><b>Taipei</b>Dispatched</span>' +
        '<span class="jm__pct">' + pct + '%</span>' +
        '<span class="jm__to"><b>' + esc(dest) + '</b>Destination</span></div>';
    }

    function timeline(pct) {
      var reached = pct >= 100 ? 4 : pct >= 88 ? 3 : pct >= 30 ? 2 : 1;
      return '<ol class="trk__steps" role="list">' + STEPS.map(function (label, i) {
        var cls = 'trk__step' + (i < reached ? ' is-done' : '') + (i === reached - 1 ? ' is-now' : '');
        return '<li class="' + cls + '"><span class="trk__dot"></span>' +
               '<span class="trk__label">' + label + '</span></li>';
      }).join('') + '</ol>';
    }

    /* Carrier scan history.

       USPS emits "Origin Post is Preparing Shipment" as filler between real
       scans -- on order #16022 it was 16 of 34 events, scattered across Los
       Angeles and Houston where it means nothing at all. Rendering the raw
       feed buries the scans that matter under a repeated non-event, so it is
       dropped. Nothing else is filtered: the rest is what the carrier said.

       Empty is normal and renders nothing. Shopify only receives scans for
       carriers it integrates with, so a destination whose post it does not
       poll has no history here and keeps the four-step timeline alone. */
    var SCAN_FILLER = /^origin post is preparing shipment$/i;
    var ORIGIN_NAMES = { TW: 'Taiwan' };

    function titleish(s) {
      /* Carriers shout: "CYPRESS, TX, US". Sentence-case the words but leave
         short all-caps tokens alone, because "TX" must not become "Tx". */
      if (s.length <= 3 && s === s.toUpperCase()) { return s; }
      return s.toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
    }

    function place(loc) {
      if (!loc) { return ''; }
      var parts = loc.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      /* A bare country code, which is all the Taiwan leg carries. */
      if (parts.length === 1 && parts[0].length === 2) {
        return ORIGIN_NAMES[parts[0].toUpperCase()] || parts[0].toUpperCase();
      }
      /* Drop a trailing country code -- "Cypress, TX" reads, "Cypress, TX, US"
         is noise once the map above already says United States. */
      if (parts.length > 1 && parts[parts.length - 1].length === 2) { parts.pop(); }
      return parts.map(titleish).join(', ');
    }

    function scanRow(e, isLatest) {
      var d = new Date(e.at);
      var day = d.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });
      var time = d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
      var where = place(e.location);
      return '<li class="scan__ev' + (isLatest ? ' is-latest' : '') + '">' +
        '<span class="scan__dot" aria-hidden="true"></span>' +
        '<span class="scan__when"><b>' + esc(day) + '</b>' + esc(time) + '</span>' +
        '<span class="scan__what">' + esc(e.message) +
          (where ? '<span class="scan__where">' + esc(where) + '</span>' : '') +
        '</span></li>';
    }

    function scanlog(f) {
      var evs = (f.events || []).filter(function (e) {
        return e.message && !SCAN_FILLER.test(e.message.trim());
      });
      if (!evs.length) { return ''; }

      var SHOW = 5;
      var head = evs.slice(0, SHOW).map(function (e, i) { return scanRow(e, i === 0); }).join('');
      var rest = evs.slice(SHOW).map(function (e) { return scanRow(e, false); }).join('');

      return '<div class="scan">' +
        '<h3 class="scan__h">Tracking updates</h3>' +
        '<ol class="scan__list" role="list">' + head + '</ol>' +
        (rest
          ? '<details class="scan__more"><summary>Show all ' + evs.length + ' updates</summary>' +
            '<ol class="scan__list" role="list">' + rest + '</ol></details>'
          : '') +
        /* Shopify gives happenedAt in UTC with no offset, so a scan's own local
           time cannot be reconstructed. Rendering in the viewer's timezone is
           right for the usual case -- the customer is where the parcel was
           delivered -- but it is wrong often enough (viewing from abroad, and
           the Taiwan leg either way) that the caption has to say whose clock
           this is. Viewing #16022 from Taipei showed a Texas delivery as
           "Aug 30, 02:33" when the customer received it on the 29th. */
        '<p class="scan__src">Scans as the carrier reported them, shown in your ' +
          'device&rsquo;s timezone. Gaps are normal &mdash; a parcel is only ' +
          'recorded where it is handled.</p>' +
      '</div>';
    }

    function shipment(f, dest, cc) {
      var t = (f.tracking && f.tracking[0]) || {};
      var pct = progress(f);
      var awaiting = PCT[f.status] == null;
      var head = '<div class="trk__head"><div>' +
        '<span class="lbl">Shipped ' +
          esc(new Date(f.createdAt).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' })) +
        '</span>' +
        (t.number ? '<div class="trk__num"><span class="lbl">Tracking number</span><code>' +
                    esc(t.number) + '</code></div>' : '') +
        '</div>' +
        /* Only while it is still a prediction. Telling someone it was
           "expected by the 30th" about a parcel already in their hands is
           noise, and after delivery the date is not even true any more. */
        (f.estimatedDelivery && f.status !== 'delivered'
          ? '<div class="trk__eta"><span class="lbl">Expected by</span><b>' +
            esc(new Date(f.estimatedDelivery).toLocaleDateString(undefined,
              { day: '2-digit', month: 'short' })) + '</b></div>'
          : '') +
        '</div>';
      /* Route on the DESTINATION country, not on Shopify's carrier field.
         These fulfillments come through as "Other", which produced a
         literal "Track with Other" button pointing nowhere useful. The
         Liquid twin (snippets/carrier-links.liquid) does the same thing;
         CARRIERS above is generated from it. */
      var dc = CARRIERS[cc];
      var n = encodeURIComponent(t.number || '');
      var link = '';
      if (t.number) {
        link = '<div class="trk__links">';
        if (dc) {
          link += '<a class="btn btn--solid" href="' + esc(dc[1] + n + (dc[2] || '')) +
                  '" target="_blank" rel="noopener"><span>Track with ' + esc(dc[0]) + '</span></a>';
        } else {
          link += '<a class="btn btn--solid" href="' + esc(BOTH_URL + n) +
                  '" target="_blank" rel="noopener"><span>Track this number</span></a>';
        }
        if (awaiting) {
          link += '<p class="trk__why">' + (dc
            ? esc(dc[0]) + ' normally shows the parcel only once it lands in ' + esc(dest) +
              ', which is usually 5&ndash;10 days after dispatch. Until then the export scans from Taiwan are the live ones.'
            : 'Your destination post normally shows the parcel only once it lands, usually 5&ndash;10 days after dispatch. Until then the export scans from Taiwan are the live ones.') +
            '</p>';
        }
        link += '<div class="trk__alt">' +
          '<a href="' + esc(BOTH_URL + n) + '" target="_blank" rel="noopener">Both legs on one page</a>' +
        '</div></div>';
      }
      return '<article class="trk__ship">' + head + journey(pct, dest, cc) + timeline(pct) +
             scanlog(f) + link + '</article>';
    }

    function render(o) {
      var dest = (o.shipTo && o.shipTo.country) || 'Your address';
      var cc = (o.shipTo && o.shipTo.countryCode) || '';
      var html = '<div class="page-head"><div class="eyebrow">Order</div><h1>' + esc(o.name) + '</h1><p>' +
        esc(new Date(o.createdAt).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' })) +
        (o.cancelled ? ' &middot; <span class="tag tag--red"><span>Cancelled</span></span>' : '') +
        '</p></div>';

      html += '<section class="trk"><h2>Where is it?</h2>';
      if (o.fulfillments && o.fulfillments.length) {
        html += o.fulfillments.map(function (f) { return shipment(f, dest, cc); }).join('');
      } else {
        /* "the moment it leaves us" reads as imminent. On an order that has
           been sitting for months it is the opposite of reassuring, so past
           the preparation windows in the shipping policy it says so and
           points at a human instead. */
        var ageDays = Math.floor((Date.now() - new Date(o.createdAt).getTime()) / 86400000);
        var round = exchangeRound(o.lines);
        if (round) {
          html += '<div class="trk__pending trk__pending--exchange">' +
                  '<span class="lbl">Waiting on Takara Tomy</span>' +
                  '<p>Your code was submitted and cross-checked. The prize itself has not ' +
                  'reached us in region yet &mdash; that part is Takara Tomy\'s to ship, and we ' +
                  'cannot pack what has not arrived. The moment it lands with us it is checked ' +
                  'and sent out with tracking.</p>' +
                  '<p><strong>Nothing is wrong with your order and there is nothing you need ' +
                  'to do.</strong></p>' +
                  '<a class="btn btn--outline" href="/pages/' + round.handle + '#status">' +
                  '<span>Live status for this round' + esc(round.label) + '</span></a>' +
                  '</div>';
        } else {
          html += '<div class="trk__pending' + (ageDays > 21 ? ' trk__pending--aged' : '') + '">' +
                  '<span class="lbl">Not shipped yet</span>' +
                  (ageDays > 21
                    ? '<p>This one has been with us longer than it should be &mdash; ' + ageDays +
                      ' days. That is past our preparation window, so please message us and we will ' +
                      'find out exactly where it stands.</p>'
                    : '<p>We will email a tracking number the moment it leaves us.</p>') +
                  '</div>';
        }
      }
      html += '</section>';

      html += '<section class="bill"><h2>What you ordered</h2>' +
        (o.lines || []).map(function (l) {
          return '<div class="bill__line"><div class="bill__media">' +
            (l.image ? '<img src="' + esc(l.image) + '" alt="" width="80" height="80" loading="lazy">' : '') +
            '<span class="bill__qty">' + esc(l.quantity) + '</span></div>' +
            '<div class="bill__txt"><div class="bill__name">' + esc(l.title) + '</div>' +
            (l.variant ? '<div class="bill__meta">' + esc(l.variant) + '</div>' : '') +
            (l.sku ? '<div class="bill__meta">' + esc(l.sku) + '</div>' : '') +
            '</div><div class="bill__price">' + esc(money(l.total)) + '</div></div>';
        }).join('');

      var tt = o.totals || {};
      html += '<dl class="bill__totals">' +
        '<div><dt>Subtotal</dt><dd>' + esc(money(tt.subtotal)) + '</dd></div>' +
        '<div><dt>Shipping</dt><dd>' +
          (tt.shipping && parseFloat(tt.shipping.amount) > 0 ? esc(money(tt.shipping)) : 'Free') + '</dd></div>' +
        (tt.tax && parseFloat(tt.tax.amount) > 0
          ? '<div><dt>Tax</dt><dd>' + esc(money(tt.tax)) + '</dd></div>' : '') +
        '<div class="bill__grand"><dt>Total</dt><dd>' + esc(money(tt.total)) + '</dd></div>' +
        '</dl></section>';

      return html;
    }

    /* Two different failures, two different messages.

       "Wrong details" and "service is down" must not look the same: telling
       a customer to check their typing when the endpoint is missing sends
       them hunting for a mistake they did not make.

       This does NOT weaken the anti-enumeration property. The lookup itself
       still answers identically for "no such order" and "wrong email" -- what
       is distinguished here is only whether the service answered at all,
       which reveals nothing about any particular order. */
    var throttleWait = 0;

    function waitPhrase() {
      if (!throttleWait) { return 'Wait a few minutes and try again.'; }
      var mins = Math.ceil(throttleWait / 60);
      return mins <= 1
        ? 'Try again in about a minute.'
        : 'Try again in about ' + mins + ' minutes.';
    }

    function fail(kind) {
      var body = kind === 'unavailable'
        ? '<p>Order lookup is temporarily unavailable &mdash; this is on us, not on what ' +
          'you entered. Your order is fine. Use the link in your shipping confirmation ' +
          'email, or sign in below if you have an account.</p>'
        : kind === 'throttled'
          ? '<p>Too many lookups from this connection. ' + waitPhrase() +
            ' Retrying sooner will not help &mdash; and if you have your tracking ' +
            'number, the link in your shipping email works right now.</p>'
          /* "Check your typing" was a dead end, and usually an unfair one: in
             every reported case the order number was right and the ORDER was
             found -- what did not match was the email, because an express
             checkout had recorded the PayPal or Shop Pay address instead of
             the one the customer thinks of as theirs. They cannot guess that,
             so the message names it, and then gives a way out instead of
             leaving them to argue with a form. */
          : '<p>We could not match that order number and email <em>together</em>. ' +
            'The order number looks like <code>#1247</code> and is at the top of your ' +
            'confirmation email.</p>' +
            '<p><b>If the number is right, the email is the mismatch.</b> It has to be the ' +
            'address the order was placed with &mdash; and if you paid with PayPal or ' +
            'Shop Pay, that is the address on <em>that</em> account, which is often not ' +
            'the one you expect.</p>' +
            '<p>Still stuck? Send us your order number on ' +
            '<a href="https://www.instagram.com/theportal0" target="_blank" rel="noopener">Instagram</a> or ' +
            '<a href="https://m.me/ThePortal0" target="_blank" rel="noopener">Messenger</a> ' +
            'and we will look it up by hand.</p>';
      out.innerHTML = '<div class="gt__result gt__result--miss">' + body + '</div>';
      out.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var order = (form.querySelector('[name="order"]').value || '').trim();
      var email = (form.querySelector('[name="email"]').value || '').trim();
      if (!order || !email) { return; }

      btn.disabled = true;
      out.hidden = false;
      out.innerHTML = '<div class="gt__result"><p class="gt__hint">Looking up your order&hellip;</p></div>';

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order: order, email: email })
      })
        .then(function (r) {
          if (r.ok) { return r.json(); }
          if (r.status === 429) {
            /* Carry the wait through so the message can say WHEN. Telling a
               locked-out customer only "too many attempts" leaves them
               nothing to do but retry. */
            throttleWait = parseInt(r.headers.get('Retry-After') || '0', 10) || 0;
            return Promise.reject('throttled');
          }
          /* 5xx is us, not them. Notably 503 not_configured, which the Worker
             returns when the app has no stored token -- without this it fell
             through to 'miss' and told the customer to check their typing
             for a service that was never installed. */
          if (r.status >= 500) { return Promise.reject('unavailable'); }
          /* The proxy answers JSON. Shopify's own 404 page is HTML, so a
             non-JSON body means the endpoint is not mounted at all. */
          var ct = r.headers.get('Content-Type') || '';
          return Promise.reject(ct.indexOf('json') === -1 ? 'unavailable' : 'miss');
        })
        .then(function (d) {
          if (!d || !d.order) { return Promise.reject('miss'); }
          out.innerHTML = '<div class="gt__order">' + render(d.order) + '</div>';
          out.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function (kind) {
          /* A thrown TypeError means the request never completed -- offline,
             DNS, CORS. That is unavailability, not a bad order number. */
          fail(typeof kind === 'string' ? kind : 'unavailable');
        })
        .then(function () { btn.disabled = false; });
    });
  }


  /* ---------- capsule reward ----------
     The same machine as initGashapon, doing a different job: it dispenses one
     real single-use $2 code per customer instead of previewing a booster's
     contents. Kept as its own function rather than a flag on that one, because
     the two must not drift into each other -- the booster machine is documented
     as never deciding anything, and this one decides something real.

     No lottery. Every capsule is the same prize, so there is nothing to weight
     and no odds to state. The theatre is the point; the outcome is fixed.

     Sign-in is asked for only at the moment of claiming, never to play. */
  /* Capsule popup.

     The dialog is native, so focus trapping, Escape, page inertness and the
     top layer all come free -- a div overlay gets at least one of those
     wrong. This only decides WHEN to open it and remembers dismissal.

     Deliberately does not nag: a customer who already claimed sees nothing,
     because the section marks itself claimed once the code comes back. And
     storage access is wrapped, since a private window can throw on read. */
  function initCapsulePopup() {
    var dlg = document.querySelector('.cappop');
    if (!dlg || typeof dlg.showModal !== 'function') { return; }

    var trigger = dlg.getAttribute('data-trigger') || 'session';
    var delay = parseInt(dlg.getAttribute('data-delay'), 10);
    if (isNaN(delay)) { delay = 4; }
    var KEY = 'tp0.capsule.seen';

    function readFlag(store) {
      try { return window[store].getItem(KEY); } catch (e) { return null; }
    }
    function writeFlag(store) {
      try { window[store].setItem(KEY, '1'); } catch (e) { /* private window */ }
    }

    function alreadyDone() {
      if (trigger === 'always') { return false; }
      if (trigger === 'once')   { return !!readFlag('localStorage'); }
      return !!readFlag('sessionStorage');
    }

    function remember() {
      if (trigger === 'once') { writeFlag('localStorage'); }
      else if (trigger === 'session') { writeFlag('sessionStorage'); }
    }

    /* Someone who has already claimed does not want to be sold it again. */
    if (dlg.querySelector('.caprw.is-claimed')) { return; }
    if (alreadyDone()) { return; }

    var opened = false;
    function open() {
      if (opened || dlg.open) { return; }
      opened = true;
      dlg.showModal();
      remember();
    }

    dlg.addEventListener('click', function (e) {
      /* click on the backdrop -- the dialog element itself -- closes it */
      if (e.target === dlg) { dlg.close(); }
      if (e.target.closest('[data-cappop-close]')) { dlg.close(); }
    });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(open, reduce ? 0 : delay * 1000);
  }

  function initCapsuleReward() {
    var sec = document.querySelector('.caprw');
    if (!sec) { return; }
    var gm     = sec.querySelector('#capMachine');
    var go     = sec.querySelector('#capGo');
    var crank  = sec.querySelector('#capCrank');
    var result = sec.querySelector('#capResult');
    if (!gm || !go || !result) { return; }

    var calm     = window.matchMedia('(prefers-reduced-motion:reduce)');
    var endpoint = sec.getAttribute('data-endpoint') || '/apps/track/reward';
    var signedIn = sec.getAttribute('data-signed-in') === '1';
    var loginUrl = sec.getAttribute('data-login') || '/account/login';
    var regUrl   = sec.getAttribute('data-register') || '/account/register';

    var stage = 'idle';        // idle | delivering | waiting | claiming | done
    var claimed = null;        // the code, once we have it

    function esc(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function paint(html, cls) {
      result.classList.remove('is-empty', 'is-in');
      result.innerHTML = html;
      result.classList.add(cls || 'is-in');
      void result.offsetWidth;
    }

    /* The prize, once it is really ours. */
    function showCode(r, repeat) {
      claimed = r;
      var ends = r.endsAt
        ? new Date(r.endsAt).toLocaleDateString(undefined, { day: '2-digit', month: 'short' })
        : '';
      paint(
        (calm.matches ? '' : '<span class="r-fx" aria-hidden="true"></span>') +
        '<span class="r-code">' + (repeat ? 'Already yours' : '$2 off') + '</span>' +
        '<span class="r-name"><code class="caprw__code">' + esc(r.code) + '</code></span>' +
        '<span class="r-raw">' +
          (repeat ? 'You claimed this earlier &mdash; it is the same code. ' : '') +
          'Enter it at checkout' + (ends ? ', before ' + esc(ends) : '') + '.' +
        '</span>'
      );
      go.querySelector('span').textContent = 'Copy the code';
      go.classList.remove('btn--pulse');
      stage = 'done';
    }

    /* Not an error: the expected state for someone who has just played. */
    function askSignIn() {
      paint(
        '<span class="r-code">Capsule open</span>' +
        '<span class="r-name">$2 off is inside</span>' +
        '<span class="r-raw">Sign in and it is yours &mdash; one per account, ' +
          'and it lands on your next order.</span>' +
        '<span class="caprw__cta">' +
          '<a class="btn btn--solid" href="' + esc(loginUrl) + '"><span>Sign in to claim</span></a>' +
          '<a class="caprw__alt" href="' + esc(regUrl) + '">Create an account</a>' +
        '</span>'
      );
      go.querySelector('span').textContent = 'Crank again';
      go.classList.remove('btn--pulse');
      stage = 'idle';
    }

    function problem(msg) {
      paint('<span class="r-code">Hold on</span><span class="r-raw">' + msg + '</span>');
      go.querySelector('span').textContent = 'Try again';
      go.classList.remove('btn--pulse');
      stage = 'idle';
    }

    function claim() {
      stage = 'claiming';
      paint('<p class="r-hint r-hint--wait">Opening the capsule&hellip;</p>', 'is-empty');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}'
      })
        .then(function (r) {
          if (r.ok) { return r.json().then(function (d) { return { d: d }; }); }
          if (r.status === 401) { return { signIn: true }; }
          if (r.status === 429) { return { msg: 'That is a lot of cranking. Give it a few minutes.' }; }
          return { msg: 'The machine is jammed on our side, not yours. Try again shortly.' };
        })
        .then(function (o) {
          if (o.signIn) { return askSignIn(); }
          if (o.msg)    { return problem(o.msg); }
          if (!o.d || !o.d.reward) {
            return problem('The machine is jammed on our side, not yours. Try again shortly.');
          }
          showCode(o.d.reward, o.d.repeat);
        })
        .catch(function () {
          problem('Could not reach the machine. Check your connection and try again.');
        });
    }

    function armOpen() {
      stage = 'waiting';
      sec.classList.add('is-armed');
      go.querySelector('span').textContent = 'Crack it open';
      go.classList.add('btn--pulse');
      result.classList.remove('is-in');
      result.classList.add('is-empty');
      result.innerHTML = '<p class="r-hint r-hint--wait">Capsule delivered</p>';
    }

    function deliver() {
      if (stage !== 'idle') { return; }
      stage = 'delivering';
      if (calm.matches) { armOpen(); return; }

      gm.className = 'gm is-cranking';
      setTimeout(function () { gm.className = 'gm is-spinning'; }, 150);
      setTimeout(function () { gm.classList.add('is-dropping'); }, 280);
      setTimeout(function () { gm.classList.remove('is-spinning'); }, 440);
      setTimeout(function () { gm.className = 'gm is-rising'; }, 580);
      setTimeout(function () { gm.className = 'gm is-waiting'; armOpen(); }, 960);
    }

    function open() {
      if (stage !== 'waiting') { return; }
      sec.classList.remove('is-armed');
      gm.className = 'gm is-open';
      /* Ask nothing of the server for someone who cannot claim yet -- the
         crank is free, and a 401 round trip to learn what the page already
         knows is just latency in front of the prompt. */
      if (!signedIn) { setTimeout(askSignIn, 220); stage = 'claiming'; return; }
      setTimeout(claim, 220);
    }

    function copyCode() {
      if (!claimed || !navigator.clipboard) { return; }
      navigator.clipboard.writeText(claimed.code).then(function () {
        var l = go.querySelector('span');
        l.textContent = 'Copied';
        setTimeout(function () { l.textContent = 'Copy the code'; }, 1600);
      }, function () { /* clipboard refused: the code is on screen anyway */ });
    }

    function turn() {
      if (stage === 'idle') { deliver(); }
      else if (stage === 'waiting') { open(); }
      else if (stage === 'done') { copyCode(); }
    }

    on(gm, 'click', function () { if (stage === 'waiting') { open(); } });
    on(go, 'click', turn);
    on(crank, 'click', turn);
  }

  function boot() {
    initMobileNav();
    initSearch();
    initGallery();
    initQuantity();
    initCartLines();
    initVariants();
    initGashapon();
    initCapsuleReward();
    initCapsulePopup();
    initShelf();
    initPolicyChrome();
    initCarrierMarquee();
    initGuestTrack();
    initLiveBanner();
    initUpload();
    initAddons();
    initBundleCart();
    initTicketLines();
    initChat();
  }

  /* Banner motion (.is-live). Several layers paint a copy of the banner they
     sit over, so they need its URL. Setting --art in the markup does not work:
     a RELATIVE url() inside a custom property resolves against the stylesheet
     in Chrome and against the document in Firefox, so the same file is wrong
     in one engine or the other. Reading it off the <img> sidesteps that -- its
     .src is absolute, and stays right through image_url and asset_url alike.
     If this never runs, those layers paint nothing and the rest of the motion
     is unaffected. */
  function initLiveBanner() {
    Array.prototype.forEach.call(document.querySelectorAll('.is-live'), function (box) {
      var img = box.querySelector('img');
      if (img) { box.style.setProperty('--art', 'url("' + img.src + '")'); }
    });
  }

  /* Upload field: drag-and-drop and a thumbnail of what was chosen.

     Built entirely at runtime around the existing input, so it adds nothing to
     main-product.liquid and cannot collide with the form mechanics there. If
     this never runs, the native file input is still present, still required,
     still submits -- the enhancement is only ever additive.

     The thumbnail matters more here than it looks: the field takes a photo of
     a winning ticket, and the failure it prevents is a customer attaching the
     wrong screenshot and finding out days later when the exchange is refused. */
  function initUpload() {
    Array.prototype.forEach.call(document.querySelectorAll('.upload'), function (box) {
      var input = box.querySelector('input[type="file"]');
      if (!input || box.querySelector('.upload__drop')) { return; }

      var drop = document.createElement('div');
      drop.className = 'upload__drop';
      drop.innerHTML =
        '<div class="upload__thumb" hidden><img alt=""></div>' +
        '<div class="upload__cta">' +
          '<p class="upload__prompt">Drag a screenshot here, or <span class="upload__link">choose a file</span></p>' +
          '<p class="upload__chosen" hidden></p>' +
        '</div>';
      input.parentNode.insertBefore(drop, input);
      drop.appendChild(input);

      var thumb = drop.querySelector('.upload__thumb');
      var img = thumb.querySelector('img');
      var chosen = drop.querySelector('.upload__chosen');
      var prompt = drop.querySelector('.upload__prompt');

      function size(bytes) {
        return bytes < 1024 * 1024
          ? Math.max(1, Math.round(bytes / 1024)) + ' KB'
          : (bytes / 1048576).toFixed(1) + ' MB';
      }

      function show() {
        var f = input.files && input.files[0];
        if (!f) {
          drop.classList.remove('is-filled');
          thumb.hidden = true; chosen.hidden = true; prompt.hidden = false;
          return;
        }
        drop.classList.add('is-filled');
        prompt.hidden = true;
        chosen.hidden = false;
        chosen.textContent = f.name + ' \u00b7 ' + size(f.size);
        if (/^image\//.test(f.type)) {
          var r = new FileReader();
          r.onload = function (e) { img.src = e.target.result; thumb.hidden = false; };
          r.readAsDataURL(f);
        } else {
          thumb.hidden = true;   /* a PDF is accepted but cannot be previewed */
        }
      }

      on(input, 'change', show);

      ['dragenter', 'dragover'].forEach(function (evt) {
        on(drop, evt, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      });
      ['dragleave', 'dragend'].forEach(function (evt) {
        on(drop, evt, function () { drop.classList.remove('is-over'); });
      });
      on(drop, 'drop', function (e) {
        e.preventDefault();
        drop.classList.remove('is-over');
        if (!e.dataTransfer || !e.dataTransfer.files.length) { return; }
        /* Assigning .files keeps the native input the single source of truth,
           so `required` and the form post behave exactly as without JS. */
        input.files = e.dataTransfer.files;
        show();
      });

      show();
    });
  }

  /* Priced add-ons. A line-item property cannot change what someone is
     charged, so each ticked add-on is a real variant on a companion product
     and enters the cart as its own line.

     Two things this has to get right, both of which the obvious version gets
     wrong:

     1. The main item goes as FormData, not JSON. /cart/add.js takes JSON for
        several items at once, but JSON cannot carry a file and would drop the
        form's other fields -- so a JSON-only version silently loses the
        colour choice and the uploaded screenshot the moment an add-on is
        ticked. FormData first for the main item, then JSON for the add-ons.

     2. The lines are bound by a shared _bundle id. Separate lines are
        separately removable, so without it a customer can delete the stadium
        and keep a $150 add-on set. initBundleCart() clears the orphans. */
  function initAddons() {
    var box = document.querySelector('[data-addons]');
    if (!box) { return; }
    var form = box.closest('form[action*="/cart/add"]');
    if (!form) { return; }

    var boxes = box.querySelectorAll('input[data-addon-variant]');
    var totalEl = box.querySelector('[data-addon-total]');

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function sync() {
      var sum = 0, n = 0;
      Array.prototype.forEach.call(boxes, function (b) {
        if (b.checked) { sum += parseInt(b.getAttribute('data-addon-price'), 10) || 0; n++; }
      });
      if (!totalEl) { return; }
      totalEl.hidden = n === 0;
      totalEl.textContent = n === 0 ? '' :
        n + (n === 1 ? ' add-on' : ' add-ons') + ' \u00b7 ' + money(sum) + ' extra';
    }

    Array.prototype.forEach.call(boxes, function (b) { on(b, 'change', sync); });
    sync();

    on(form, 'submit', function (e) {
      var picked = [];
      Array.prototype.forEach.call(boxes, function (b) {
        if (b.checked) { picked.push(b.getAttribute('data-addon-variant')); }
      });
      if (!picked.length) { return; }

      e.preventDefault();
      var group = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var fd = new FormData(form);
      fd.append('properties[_bundle]', group);

      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) { throw new Error('main'); } return r.json(); })
        .then(function () {
          var items = picked.map(function (id) {
            return { id: id, quantity: 1,
                     properties: { _bundle: group, _bundle_child: '1' } };
          });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function () { window.location = '/cart'; })
        .catch(function () {
          /* Fall back to a plain post rather than stranding the customer. The
             main product still reaches the cart; the add-ons do not. Losing
             add-ons is recoverable, losing the order is not. */
          form.submit();
        });
    });
  }

  /* Add-ons are separate cart lines, so they can outlive the thing they were
     bought for. If the parent of a _bundle group is gone, its children are
     charged-for extras attached to nothing -- clear them. Runs on the cart
     page only and does nothing when no bundle is present. */
  function initBundleCart() {
    if (!document.querySelector('.cart')) { return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var groups = {};
      cart.items.forEach(function (it, i) {
        var props = it.properties || {};
        var g = props._bundle;
        if (!g) { return; }
        groups[g] = groups[g] || { parent: false, children: [] };
        if (props._bundle_child) { groups[g].children.push(i + 1); }
        else { groups[g].parent = true; }
      });
      var orphans = [];
      Object.keys(groups).forEach(function (g) {
        if (!groups[g].parent) { orphans = orphans.concat(groups[g].children); }
      });
      if (!orphans.length) { return; }
      /* Highest line first: removing a line renumbers the ones after it. */
      orphans.sort(function (a, b) { return b - a; });
      (function next(i) {
        if (i >= orphans.length) { window.location.reload(); return; }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: orphans[i], quantity: 0 })
        }).then(function () { next(i + 1); }).catch(function () { next(i + 1); });
      })(0);
    }).catch(function () { /* leave the cart alone if it cannot be read */ });
  }

  /* The product page can fix a line to 1, but the cart can still raise it --
     and a line carrying a ticket screenshot at quantity 2 is two prizes with
     one unverifiable ticket. Lock the quantity control on any line that
     carries an uploaded file, and say why. */
  function initTicketLines() {
    if (!document.querySelector('.cart')) { return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      cart.items.forEach(function (item, i) {
        var props = item.properties || {};
        var hasFile = Object.keys(props).some(function (k) {
          return k.charAt(0) !== '_' && /^https?:\/\/.*\/uploads\//.test(String(props[k]));
        });
        if (!hasFile) { return; }
        var row = document.querySelectorAll('[data-cart-line]')[i];
        if (!row) { return; }
        Array.prototype.forEach.call(row.querySelectorAll('input[name*="quantity"],[data-step]'), function (el) {
          el.disabled = true;
        });
        row.classList.add('is-ticket-line');
      });
    }).catch(function () {});
  }

  /* Contact launcher. Toggle only -- every channel is a plain link, so the
     panel works as a list even if this never runs. Closes on Escape and on an
     outside click, because a floating panel that traps you is worse than no
     panel. */
  function initChat() {
    var root = document.querySelector('[data-chat]');
    if (!root) { return; }
    var btn = root.querySelector('[data-chat-toggle]');
    var panel = root.querySelector('#chatPanel');
    if (!btn || !panel) { return; }

    function setOpen(open) {
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-open', open);
    }
    on(btn, 'click', function () { setOpen(panel.hidden); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { setOpen(false); btn.focus(); }
    });
    on(document, 'click', function (e) {
      if (!panel.hidden && !root.contains(e.target)) { setOpen(false); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
